import React, { useState, useMemo } from 'react'

import { Modal, Radio, InputNumber, Space, Typography } from 'antd'
import { useTranslation } from 'react-i18next'

const { Text } = Typography

export default function GenerateShelfBarcodeModal({
  visible,
  selectedCount = 0,
  onCancel,
  onSubmit,
  loading = false,
}) {
  const { t } = useTranslation()

  const [contentMode, setContentMode] = useState('simple')
  const [outputMode, setOutputMode] = useState('label')
  const [labelWidth, setLabelWidth] = useState(70)
  const [labelHeight, setLabelHeight] = useState(50)
  const [columns, setColumns] = useState(3)
  const [rows, setRows] = useState(8)

  const labelsPerPage = useMemo(() => columns * rows, [columns, rows])

  const handleSubmit = () => {
    const params = {
      content_mode: contentMode,
      output_mode: outputMode,
    }

    if (outputMode === 'a4') {
      params.columns = columns
      params.rows = rows
    } else {
      params.label_width = labelWidth
      params.label_height = labelHeight
    }

    onSubmit(params)
  }

  return (
    <Modal
      title={t('shared.shelves.generate_barcode.title')}
      open={visible}
      onCancel={onCancel}
      onOk={handleSubmit}
      okText={t('shared.shelves.generate_barcode.submit')}
      confirmLoading={loading}
      width={520}
      destroyOnClose
    >
      <Text type="secondary" style={{ display: 'block', marginBottom: 16 }}>
        {t('shared.shelves.generate_barcode.selected_count', { count: selectedCount })}
      </Text>

      {/* 標籤內容 */}
      <div style={{ marginBottom: 20 }}>
        <Text strong style={{ display: 'block', marginBottom: 8 }}>
          {t('shared.shelves.generate_barcode.content_mode')}
        </Text>
        <Radio.Group value={contentMode} onChange={(e) => setContentMode(e.target.value)}>
          <Space direction="vertical">
            <Radio value="simple">{t('shared.shelves.generate_barcode.content_simple')}</Radio>
            <Radio value="detailed">
              {t('shared.shelves.generate_barcode.content_detailed')}
              <Text type="secondary" style={{ display: 'block', marginLeft: 24, fontSize: 12 }}>
                {t('shared.shelves.generate_barcode.content_detailed_desc')}
              </Text>
            </Radio>
          </Space>
        </Radio.Group>
      </div>

      {/* 輸出模式 */}
      <div style={{ marginBottom: 20 }}>
        <Text strong style={{ display: 'block', marginBottom: 8 }}>
          {t('shared.shelves.generate_barcode.output_mode')}
        </Text>
        <Radio.Group value={outputMode} onChange={(e) => setOutputMode(e.target.value)}>
          <Space>
            <Radio value="label">{t('shared.shelves.generate_barcode.output_label')}</Radio>
            <Radio value="a4">{t('shared.shelves.generate_barcode.output_a4')}</Radio>
          </Space>
        </Radio.Group>
      </div>

      {/* 標籤尺寸（標籤模式）*/}
      {outputMode === 'label' && (
        <div style={{ marginBottom: 20, padding: 16, background: '#fafafa', borderRadius: 8 }}>
          <Text strong style={{ display: 'block', marginBottom: 12 }}>
            {t('shared.shelves.generate_barcode.label_size')}
          </Text>
          <Space size={16} align="center">
            <div>
              <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>
                {t('shared.shelves.generate_barcode.label_width')}
              </Text>
              <InputNumber min={20} max={300} value={labelWidth} onChange={setLabelWidth} />
            </div>
            <Text style={{ marginTop: 16 }}>×</Text>
            <div>
              <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>
                {t('shared.shelves.generate_barcode.label_height')}
              </Text>
              <InputNumber min={15} max={300} value={labelHeight} onChange={setLabelHeight} />
            </div>
          </Space>
        </div>
      )}

      {/* A4 排版設定 */}
      {outputMode === 'a4' && (
        <div style={{ marginBottom: 20, padding: 16, background: '#fafafa', borderRadius: 8 }}>
          <Text strong style={{ display: 'block', marginBottom: 12 }}>
            {t('shared.shelves.generate_barcode.a4_layout')}
          </Text>
          <Space size={16} align="center">
            <div>
              <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>
                {t('shared.shelves.generate_barcode.columns')}
              </Text>
              <InputNumber min={1} max={6} value={columns} onChange={setColumns} />
            </div>
            <Text style={{ marginTop: 16 }}>×</Text>
            <div>
              <Text type="secondary" style={{ display: 'block', fontSize: 12, marginBottom: 4 }}>
                {t('shared.shelves.generate_barcode.rows')}
              </Text>
              <InputNumber min={1} max={15} value={rows} onChange={setRows} />
            </div>
            <Text type="secondary" style={{ marginTop: 16 }}>
              = {t('shared.shelves.generate_barcode.labels_per_page', { count: labelsPerPage })}
            </Text>
          </Space>
        </div>
      )}
    </Modal>
  )
}
